import { render, staticRenderFns } from "./policySubResult.vue?vue&type=template&id=29fea077&scoped=true&"
import script from "./policySubResult.vue?vue&type=script&lang=js&"
export * from "./policySubResult.vue?vue&type=script&lang=js&"
import style0 from "./policySubResult.vue?vue&type=style&index=0&id=29fea077&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fea077",
  null
  
)

export default component.exports